import type {
  INeoTicketController,
  INeoTicketService,
} from "../../core/ports/driver/neoTicketService";

/**
 * Neo Tickets controller. Exposes the service surface directly (no extra
 * presentation-layer adaptation), kept as its own factory for consistency with
 * the rest of the hexagon (page → controller → service → repository).
 */
export const NeoTicketControllerFactory = ({
  neoTicketService,
}: {
  neoTicketService: INeoTicketService;
}): INeoTicketController => {
  return {
    listTickets: neoTicketService.listTickets,
    getTicket: neoTicketService.getTicket,
    createTicket: neoTicketService.createTicket,
    updateTicket: neoTicketService.updateTicket,
    appendTicketBlocks: neoTicketService.appendTicketBlocks,
    cancelTicket: neoTicketService.cancelTicket,
    deleteTicket: neoTicketService.deleteTicket,
  };
};
